import PropTypes from 'prop-types'

import ContentItem from './ContentItem'

const ContentList = ({ contents = [], currentTerm }) => {
  const listContents = () => {
    return contents.map(
      (content, index) =>
        <ContentItem key={ index } { ...content } currentTerm={currentTerm} />
    )
  }

  return (
    <div className="content-list">
      <div className="row no-margin">
        <h3 className="heading-4 padding-x-small no-margin">
          Conteúdo relacionado
        </h3>
      </div>
      <ul className="content-list-results padding-small margin-top">
        { listContents() }
      </ul>
    </div>
  )
}

ContentList.propTypes = {
  contents: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    url: PropTypes.string.isRequired
  }))
}

export default ContentList
